/* on-rayon.js — rayons, recherche et /collections (refonte DA, 05/10/2026, lot L2).
   Portage du comportement « plp » du site de référence (initPLP) sur les données ON :
   - groupes de la page = window.onProduitsContexte() (rayon, gamme, couleur, recherche) ;
   - onglets de catégorie (button.coll__filtre[data-filtre]) avec compteurs, onglet vide masqué ;
   - volet « Filtrer & trier » (#panneauFiltres) : Trier par, Activité (sous-catégories présentes), Pointures (#collTailles,
     tailles DISPONIBLES dans la sélection, ordre croissant) ; OU dans un groupe, ET entre les groupes ; pilules + « Tout effacer » ;
   - état dans l'URL (cat, activite, taille, tri, vus), relu au chargement : les liens du méga-menu ?cat= et ?activite= en dépendent ;
   - grille #collGrille de cartes ON.carte, « Voir plus » par 24.
   Défauts de la référence non repris : compteur « 97résultats » collé, libellé « Voir plus » réécrit, libellé de pilule brut,
   TypeError sur un data-f inconnu, défilement sous le volet (verrou sur <html> ET <body>), 471 images chargées d'emblée. */
(function () {
  'use strict';
  var PAS = 24;
  var CATS = ['chaussures', 'vetements', 'accessoires'];
  // Ordre des activités du menu (tools/chiffres.mjs) ; les autres sous-catégories suivent par nombre de modèles.
  var ORDRE_ACT = ['running-sur-route', 'trail-running', 'randonnee', 'lifestyle', 'chaussures-de-tennis', 'training-et-fitness', 'athletisme'];
  var SPORTS = { 'running-sur-route': 1, 'trail-running': 1, 'randonnee': 1, 'lifestyle': 1, 'chaussures-de-tennis': 1, 'training-et-fitness': 1, 'athletisme': 1, 'autres': 1 };
  var LETTRES = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
  var TRIS = { selection: 1, 'prix-asc': 1, 'prix-desc': 1 };
  // Anciens liens à ancre du gabarit précédent (#chaussures, #running…) : traduits une fois en paramètres.
  var ANCRES = { chaussures: ['cat', 'chaussures'], vetements: ['cat', 'vetements'], accessoires: ['cat', 'accessoires'],
    running: ['activite', 'running-sur-route'], lifestyle: ['activite', 'lifestyle'] };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  // Même règle que ON.slug et tools/chiffres.mjs : minuscules, sans accents, tout le reste → « - ».
  function slug(s) {
    if (window.ON && typeof ON.slug === 'function') return ON.slug(s);
    return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function norm(t) { return String(t).replace(',', '.').trim(); }
  // Rang d'une taille (décision M3 : pointures croissantes, puis lettres XXS → XXXL) ; libellés composés exclus (-1).
  function rangT(t) {
    t = norm(t);
    if (/^\d+(\.\d+)?$/.test(t)) return parseFloat(t);
    var i = LETTRES.indexOf(t.toUpperCase());
    return i >= 0 ? 1000 + i : -1;
  }
  function estPointure(t) { var r = rangT(t); return r >= 0 && r < 1000; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function prixPaye(c) { return (c && (c.promo || c.prix)) || 0; }
  function liste(v) { return String(v || '').split(',').map(function (x) { return x.trim(); }).filter(Boolean); }
  var mqMobile = window.matchMedia('(max-width: 899.98px)');
  // Catalogue absent ou vide (on-catalogue.js non chargé, fichier vide ou cassé ; réécrit par le Worker depuis le 05/10/2026) :
  // ce n'est PAS « aucun modèle ». Message distinct et bouton « Recharger » ; ni barre, ni volet, ni « Voir plus ».
  function catalogueDispo() { return Array.isArray(window.CATALOGUE) && window.CATALOGUE.length > 0; }
  function indisponible() {
    ['#collFiltres', '#plpTete .plp-bar', '#panneauFiltres', '#plpPlus'].forEach(function (s) { var x = $(s); if (x) x.hidden = true; });
    var vide = $('#collVide');
    if (!vide) return;
    vide.innerHTML = '<p>Le catalogue est momentanément indisponible. Rechargez la page.</p>' +
      '<button type="button" class="btn btn--outline plp-vide__lien" id="collRecharger">Recharger</button>';
    vide.hidden = false;
    $('#collRecharger').addEventListener('click', function () { location.reload(); });
  }

  function init() {
    var grille = $('#collGrille');
    // Recherche sans résultat Shopify (pas de grille) : le message du serveur vaut, il ne dépend pas du catalogue.
    if (grille && !catalogueDispo()) { indisponible(); return; }
    var ctx = window.ON_CONTEXTE || {};
    var base = (typeof window.onProduitsContexte === 'function' ? window.onProduitsContexte() : (window.CATALOGUE || [])) || [];
    // Recherche : Shopify ne rend que 250 fiches par page (« cloud » : 961 fiches, 233 modèles → 69 ou 70 modèles selon le chargement,
    // alors que la recherche instantanée de l'en-tête annonce 233 et renvoie ici pour « voir tous les résultats »). On complète avec
    // la MÊME règle qu'elle (on-app.js § 9 : ET sur tous les mots, sans accents ni casse, sur nom, rayon, catégories, réf. et
    // coloris), dans l'ordre du catalogue : la page montre au moins ce que le panneau annonçait.
    if (ctx.cle === 'recherche' && ctx.q && window.CATALOGUE) {
      var normaliser = (window.ON && typeof ON.normaliser === 'function') ? ON.normaliser : function (s) { return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); };
      var mots = normaliser(ctx.q).split(/\s+/).filter(Boolean);
      var deja = {}; base.forEach(function (g) { deja[g.id] = 1; });
      if (mots.length) base = window.CATALOGUE.filter(function (g) {
        if (deja[g.id]) return true;
        var foin = normaliser([g.nom, g.rayon, g.categorie, g.sous_cat, g.ref].concat((g.coloris || []).map(function (c) { return c.couleur; })).join(' '));
        return mots.every(function (m) { return foin.indexOf(m) !== -1; });
      });
    }
    // Données dérivées, calculées une fois par groupe.
    base.forEach(function (g, i) {
      g.__rang = i;
      g.__cat = slug(g.categorie);
      g.__act = slug(g.sous_cat);
      var t = {};
      (g.coloris || []).forEach(function (c) { (c.tailles || []).forEach(function (x) { t[norm(x)] = 1; }); });
      g.__tailles = t;
    });

    var etat = { cat: [], activite: [], taille: [], tri: 'selection', vus: PAS };
    var nomAct = {};   // slug → libellé (sous_cat)
    base.forEach(function (g) { if (g.__act && !nomAct[g.__act]) nomAct[g.__act] = g.sous_cat; });

    // --- URL : lecture (avec garde sur chaque valeur) -------------------------------------------------------------------
    (function lireURL() {
      var u = new URLSearchParams(location.search);
      etat.cat = liste(u.get('cat')).filter(function (v) { return CATS.indexOf(v) >= 0; });
      // Seules les activités de la sélection : une valeur inconnue (?activite=bidon) s'affichait telle quelle en case cochée et en pilule.
      etat.activite = liste(u.get('activite')).filter(function (v) { return /^[a-z0-9-]+$/.test(v) && nomAct[v]; });
      // Seules les tailles proposées par la sélection (?taille=99 affichait une pilule « EU 99 » et 0 résultat).
      var dispo = {}; base.forEach(function (g) { for (var k in g.__tailles) dispo[k] = 1; });
      etat.taille = liste(u.get('taille')).map(norm).filter(function (v) { return rangT(v) >= 0 && dispo[v]; });
      var t = u.get('tri'); if (t && TRIS[t]) etat.tri = t;
      var n = parseInt(u.get('vus'), 10); if (n > PAS) etat.vus = Math.min(n, 2000);
      var a = location.hash.slice(1);
      if (ANCRES[a]) {
        var k = ANCRES[a];
        if (!etat[k[0]].length) etat[k[0]] = [k[1]];
        try { history.replaceState(history.state, '', location.pathname + location.search); } catch (e) {}
      }
    })();

    if (!grille) return;   // recherche sans résultat : rien d'autre à rendre

    // --- Filtres ---------------------------------------------------------------------------------------------------------
    function passeCat(g) { return !etat.cat.length || etat.cat.indexOf(g.__cat) >= 0; }
    function passeAct(g) { return !etat.activite.length || etat.activite.indexOf(g.__act) >= 0; }
    function passeTaille(g) {
      if (!etat.taille.length) return true;
      // Une seule taille suffit : le visiteur cherche ce qui lui va (comme la référence).
      return etat.taille.some(function (t) { return g.__tailles[t]; });
    }
    function selectionCat() { return base.filter(passeCat); }
    function resultats() {
      var l = base.filter(function (g) { return passeCat(g) && passeAct(g) && passeTaille(g); });
      if (etat.tri === 'prix-asc' || etat.tri === 'prix-desc') {
        var sens = etat.tri === 'prix-asc' ? 1 : -1;
        l.sort(function (a, b) { return (prixPaye(colorisDe(a)) - prixPaye(colorisDe(b))) * sens || a.__rang - b.__rang; });
      }
      return l;
    }
    // Coloris montré par la carte : avec une taille choisie, le premier coloris qui l'a en stock.
    function indexColoris(g) {
      if (!etat.taille.length) return 0;
      var i = 0;
      (g.coloris || []).some(function (c, k) {
        var ok = (c.tailles || []).some(function (x) { return etat.taille.indexOf(norm(x)) >= 0; });
        if (ok) i = k; return ok;
      });
      return i;
    }
    function colorisDe(g) { return (g.coloris || [])[indexColoris(g)] || (g.coloris || [])[0]; }

    // --- Onglets de catégorie ----------------------------------------------------------------------------------------------
    var onglets = $$('#collFiltres .coll__filtre[data-filtre]');
    var compteCat = { '': base.length };
    CATS.forEach(function (k) { compteCat[k] = base.filter(function (g) { return g.__cat === k; }).length; });
    // Une seule catégorie non vide (boutique 100 % chaussures, 05/10/2026) : la rangée « Tout voir / Chaussures » ne dit rien → masquée.
    if (CATS.filter(function (k) { return compteCat[k] > 0; }).length <= 1) { var rangee = $('#collFiltres'); if (rangee) rangee.hidden = true; }
    onglets.forEach(function (b) {
      var k = b.getAttribute('data-filtre') || '';
      var nb = b.querySelector('.coll__filtre-nb');
      if (nb) nb.textContent = '(' + (compteCat[k] || 0) + ')';
      b.hidden = !compteCat[k] && etat.cat.indexOf(k) < 0;
      b.addEventListener('click', function () {
        etat.cat = k ? [k] : [];
        etat.vus = PAS;
        rendre();
      });
    });
    function majOnglets() {
      onglets.forEach(function (b) {
        var k = b.getAttribute('data-filtre') || '';
        var actif = k ? (etat.cat.length === 1 && etat.cat[0] === k) : !etat.cat.length;
        b.classList.toggle('is-actif', actif);
        b.classList.toggle('actif', actif);
        b.setAttribute('aria-pressed', String(actif));
        if (actif) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current');
      });
    }

    // --- Volet : Activité ----------------------------------------------------------------------------------------------------
    var grpAct = $('#fltrActivites'), titreAct = $('#fltrActivitesTitre');
    function majActivites() {
      if (!grpAct) return;
      var n = {};
      selectionCat().forEach(function (g) { if (g.__act) n[g.__act] = (n[g.__act] || 0) + 1; });
      etat.activite.forEach(function (v) { if (!n[v]) n[v] = 0; });   // une case cochée reste décochable
      var cles = Object.keys(n).sort(function (a, b) {
        var ia = ORDRE_ACT.indexOf(a), ib = ORDRE_ACT.indexOf(b);
        if (ia >= 0 || ib >= 0) return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        return n[b] - n[a] || a.localeCompare(b);
      });
      $$('.fltr-case', grpAct).forEach(function (x) { x.remove(); });
      if (cles.length < 2 && !etat.activite.length) { grpAct.hidden = true; return; }
      var h = '';
      cles.forEach(function (k) {
        h += '<label class="fltr-case"><input type="checkbox" data-f="activite" value="' + esc(k) + '"' + (etat.activite.indexOf(k) >= 0 ? ' checked' : '') +
          '><span>' + esc(nomAct[k] || k) + '</span></label>';
      });
      grpAct.insertAdjacentHTML('beforeend', h);
      // « Activité » pour les usages de chaussures ; « Catégorie » dès qu'un type de vêtement ou d'accessoire est proposé.
      if (titreAct) titreAct.textContent = cles.every(function (k) { return SPORTS[k]; }) ? 'Activité' : 'Catégorie';
      grpAct.hidden = false;
    }

    // --- Volet : Pointures (#collTailles) -----------------------------------------------------------------------------------
    var grpT = $('#fltrTailles'), titreT = $('#fltrTaillesTitre'), zoneT = $('#collTailles');
    function majTailles() {
      if (!zoneT || !grpT) return;
      var vu = {};
      base.forEach(function (g) {
        if (!(passeCat(g) && passeAct(g))) return;
        Object.keys(g.__tailles).forEach(function (t) { if (rangT(t) >= 0) vu[t] = 1; });
      });
      etat.taille.forEach(function (t) { vu[t] = 1; });
      var l = Object.keys(vu).sort(function (a, b) { return rangT(a) - rangT(b); });
      zoneT.textContent = '';
      if (l.length < 2 && !etat.taille.length) { grpT.hidden = true; return; }
      var p = l.filter(estPointure), le = l.filter(function (t) { return !estPointure(t); });
      if (titreT) titreT.textContent = !le.length ? 'Pointures (EU)' : (!p.length ? 'Tailles' : 'Pointures et tailles');
      var h = '';
      function groupe(lib, tl) {
        if (!tl.length) return;
        if (p.length && le.length) h += '<span class="coll__tailles-lib">' + lib + '</span>';
        tl.forEach(function (t) {
          var on = etat.taille.indexOf(t) >= 0;
          h += '<button type="button" class="coll__filtre fltr-taille' + (on ? ' actif' : '') + '" data-taille="' + esc(t) + '" aria-pressed="' + on + '">' +
            '<span class="fltr-taille__boite" aria-hidden="true"></span><span>' + esc(t) + '</span></button>';
        });
      }
      groupe('Pointures (EU)', p); groupe('Tailles', le);
      zoneT.innerHTML = h;
      grpT.hidden = false;
    }
    if (zoneT) zoneT.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-taille]');
      if (!b) return;
      var t = b.getAttribute('data-taille');
      var i = etat.taille.indexOf(t);
      if (i < 0) etat.taille.push(t); else etat.taille.splice(i, 1);
      etat.vus = PAS;
      rendre({ garderFocus: '[data-taille="' + t.replace(/"/g, '') + '"]' });
    });

    // --- Cases (Activité) et tri ----------------------------------------------------------------------------------------------
    var panneau = $('#panneauFiltres');
    if (panneau) panneau.addEventListener('change', function (e) {
      var i = e.target;
      if (i.name === 'plpTri') { if (TRIS[i.value]) { etat.tri = i.value; etat.vus = PAS; rendre(); } return; }
      var f = i.getAttribute && i.getAttribute('data-f');
      if (!f || !etat[f] || !Array.isArray(etat[f])) return;   // garde : data-f inconnu (défaut 29 de la référence)
      var l = etat[f];
      if (i.checked) { if (l.indexOf(i.value) < 0) l.push(i.value); }
      else etat[f] = l.filter(function (x) { return x !== i.value; });
      etat.vus = PAS;
      rendre({ garderFocus: 'input[data-f="' + f + '"][value="' + i.value + '"]' });
    });
    function syncTri() {
      $$('#panneauFiltres input[name="plpTri"]').forEach(function (r) { r.checked = r.value === etat.tri; });
    }

    // --- Filtres appliqués ------------------------------------------------------------------------------------------------------
    function pills() {
      var zone = $('#fltrApplique'), hote = $('#fltrPills');
      if (!zone || !hote) return;
      hote.textContent = '';
      var tout = [];
      etat.activite.forEach(function (v) { tout.push(['activite', v, nomAct[v] || v]); });
      etat.taille.forEach(function (v) { tout.push(['taille', v, (estPointure(v) ? 'EU ' : 'Taille ') + v]); });
      tout.forEach(function (f) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'fltr-pill';
        var lib = document.createElement('span'); lib.textContent = f[2];
        var croix = document.createElement('i'); croix.setAttribute('aria-hidden', 'true'); croix.textContent = '×';
        b.appendChild(lib); b.appendChild(croix);
        b.setAttribute('aria-label', 'Retirer le filtre ' + f[2]);
        b.addEventListener('click', function () {
          etat[f[0]] = etat[f[0]].filter(function (x) { return x !== f[1]; });
          etat.vus = PAS;
          rendre({ garderFocus: '#fltrPills .fltr-pill, #fltrClear' });
        });
        hote.appendChild(b);
      });
      zone.hidden = tout.length === 0;
    }
    var clear = $('#fltrClear');
    if (clear) clear.addEventListener('click', function () {
      etat.activite = []; etat.taille = []; etat.tri = 'selection'; etat.vus = PAS;
      rendre({ garderFocus: '#fltrTitre' });
    });

    // --- Ouverture du volet -----------------------------------------------------------------------------------------------------
    var bouton = $('#plpFiltres');
    function ouvert() { return !!panneau && !panneau.hidden; }
    function actifs() { return etat.activite.length + etat.taille.length; }
    function majBouton() {
      if (!bouton) return;
      var n = actifs();
      var txt = $('#plpFiltresTxt');
      var lib = (ouvert() ? 'Cacher les filtres' : 'Afficher filtres') + (n ? ' (' + n + ')' : '');
      if (txt) txt.textContent = lib;
      bouton.setAttribute('aria-expanded', String(ouvert()));
    }
    function classes(on) {
      document.documentElement.classList.toggle('a-filtres', on);
      document.body.classList.toggle('a-filtres', on);
    }
    var parPanneauON = false;
    function ouvrir() {
      if (!panneau || ouvert()) return;
      panneau.hidden = false;
      classes(true);
      if (mqMobile.matches) {
        // Plein écran : dialogue modal (verrou, focus piégé, Échap) fourni par ON.panneau.
        panneau.setAttribute('role', 'dialog'); panneau.setAttribute('aria-modal', 'true');
        if (window.ON && ON.panneau && typeof ON.panneau.ouvrir === 'function') {
          try { ON.panneau.ouvrir('panneauFiltres', bouton, { voile: false, classe: 'fltr-ouvert', focus: '#fltrFermer' }); parPanneauON = true; } catch (e) { parPanneauON = false; }
        }
        if (!parPanneauON) { var f = $('#fltrFermer'); if (f) f.focus(); }
      }
      // Bureau : 4 colonnes plus étroites ; les cartes rendues ensuite (filtres, « Voir plus ») prennent le `sizes` du volet. Celles
      // déjà affichées gardent leur image (Chrome réutilise celle déjà téléchargée, même sur un élément recréé : mesuré, 0 octet de plus).
      majTaillesImages();
      majHauteur();
      majBouton();
    }
    function fermer(rendreFocus) {
      if (!panneau || !ouvert()) return;
      panneau.hidden = true;
      classes(false);
      panneau.removeAttribute('role'); panneau.removeAttribute('aria-modal');
      if (parPanneauON) { parPanneauON = false; try { if (ON.panneau.fermer) ON.panneau.fermer(); } catch (e) {} }
      majTaillesImages();
      majHauteur();
      majBouton();
      if (rendreFocus && bouton) bouton.focus();
    }
    document.addEventListener('on:panneau', function (e) {
      // ON.panneau a fermé le volet (ou en a ouvert un autre : menu, tiroir) : l'état du rayon suit.
      var d = (e && e.detail) || {};
      if (!ouvert() || !parPanneauON) return;
      if ((d.id === 'panneauFiltres' && !d.ouvert) || (d.id !== 'panneauFiltres' && d.ouvert)) { parPanneauON = false; fermer(d.id === 'panneauFiltres'); }
    });
    if (bouton) bouton.addEventListener('click', function () { if (ouvert()) fermer(); else ouvrir(); });
    var bFermer = $('#fltrFermer');
    if (bFermer) bFermer.addEventListener('click', function () { fermer(true); });
    var voir = $('#fltrVoir');
    // « Voir les N résultats » : comme la référence, la page reste où elle était (ON.panneau rend la position d'ouverture). On ne la
    // recale que si la barre n'est pas visible SOUS l'en-tête collant : un scrollIntoView({block:'start'}) la glissait sous l'en-tête
    // (mesuré à 390 : bouton « Afficher filtres (2) » et compteur cachés, page descendue de 0 à 273 px).
    function basEntete() {
      var h = document.getElementById('hdr');
      if (!h) return 0;
      var p = getComputedStyle(h).position, r = h.getBoundingClientRect();
      return (p === 'sticky' || p === 'fixed') && r.bottom > 0 ? r.bottom : 0;
    }
    if (voir) voir.addEventListener('click', function () {
      fermer(false);
      var g = $('#plpTete .plp-bar') || grille;
      var r = g.getBoundingClientRect(), haut = basEntete();
      if (r.top < haut || r.top > window.innerHeight * 0.6) window.scrollTo(0, Math.max(0, window.scrollY + r.top - haut - 12));
      if (bouton) bouton.focus({ preventScroll: true });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && ouvert()) { e.stopPropagation(); fermer(true); }
    }, true);
    if (panneau) panneau.addEventListener('click', function (e) { if (e.target === panneau && mqMobile.matches) fermer(true); });
    // Passage du point de rupture volet ouvert : la colonne deviendrait un plein écran que rien ne referme (référence).
    var surChange = function () { if (ouvert()) fermer(false); else majTaillesImages(); };
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', surChange); else if (mqMobile.addListener) mqMobile.addListener(surChange);

    // --- Grille ------------------------------------------------------------------------------------------------------------------
    // sizes EXACT par contexte : 2 colonnes (50vw), 3 colonnes (33vw / 30vw) ; volet ouvert au bureau : 2 à 4 colonnes plus étroites.
    var SIZES = '(min-width: 1000px) 30vw, (min-width: 700px) 33vw, 50vw';
    var SIZES_VOLET = '(min-width: 1200px) 21vw, (min-width: 900px) 31vw, 50vw';
    // Bureau, volet ouvert : il est en position absolue (référence) et peut mesurer 1 400 px (14 activités + 29 tailles) ; la grille
    // garde au moins sa hauteur, sinon il recouvre « Voir plus », le bloc SEO et la newsletter (la référence ne réservait que 820 px).
    function majHauteur() {
      if (!ouvert() || mqMobile.matches) { grille.style.minHeight = ''; return; }
      grille.style.minHeight = '';
      var h = panneau.getBoundingClientRect().bottom - grille.getBoundingClientRect().top + 30;
      if (h > grille.offsetHeight) grille.style.minHeight = Math.ceil(h) + 'px';
    }
    window.addEventListener('resize', function () { if (ouvert()) majHauteur(); }, { passive: true });
    function sizesCourant() { return ouvert() && !mqMobile.matches ? SIZES_VOLET : SIZES; }
    function majTaillesImages() {
      var s = sizesCourant();
      $$('img[sizes]', grille).forEach(function (im) { if (!im.closest('.swatches')) im.sizes = s; });
    }
    function premiers() { return window.matchMedia('(min-width: 700px)').matches ? 3 : 2; }
    function carte(g, i) {
      var opts = { coloris: colorisDe(g), eager: i < premiers(), sizes: sizesCourant() };
      if (window.ON && typeof ON.carte === 'function') {
        var r = ON.carte(g, opts);
        if (r && typeof r === 'object' && r.nodeType) return r;
        var t = document.createElement('template'); t.innerHTML = String(r || '').trim();
        return t.content.firstElementChild;
      }
      return carteSecours(g, opts);
    }
    // Carte minimale si l'API commune manque (le rayon reste utilisable) : même balisage de base que la référence.
    function carteSecours(g, o) {
      var c = o.coloris || (g.coloris || [])[0] || {};
      var img = (c.images || [])[0] || g.image || '';
      var a = document.createElement('a');
      a.className = 'card'; a.href = c.url || g.url;
      var paye = prixPaye(c), barre = c.prix && c.promo && c.promo < c.prix ? c.prix : 0;
      var src = function (w) { return img ? img + (img.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w : ''; };
      a.innerHTML = '<div class="card__media">' + (img ? '<img src="' + esc(src(540)) + '" srcset="' + [360, 540, 720, 900].map(function (w) { return esc(src(w)) + ' ' + w + 'w'; }).join(', ') +
        '" sizes="' + o.sizes + '" alt="' + esc(g.nom) + '" width="900" height="900"' + (o.eager ? '' : ' loading="lazy"') + ' decoding="async">' : '') + '</div>' +
        '<div class="card__body"><div class="card__name"><span>' + esc(g.nom) + '</span></div><div class="card__desc">' + esc([g.rayon, g.sous_cat].filter(Boolean).join(' – ')) + '</div>' +
        '<div class="price">' + (barre ? '<s>' + prix(barre) + '</s>' : '') + '<b>' + prix(paye) + '</b></div></div>';
      return a;
    }
    function prix(n) {
      if (window.ON && typeof ON.prix === 'function') return ON.prix(n);
      return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(n);
    }

    var courant = [], affiches = 0;

    function remplir(jusqua) {
      var frag = document.createDocumentFragment();
      for (var i = affiches; i < Math.min(jusqua, courant.length); i++) {
        var el = carte(courant[i], i);
        if (el) frag.appendChild(el);
      }
      grille.appendChild(frag);
      grille.classList.add('is-rendu');
      affiches = Math.max(affiches, Math.min(jusqua, courant.length));
      if (window.ON && typeof ON.cartes === 'function') { try { ON.cartes(grille); } catch (e) {} }   // pastilles, flèches, cœurs
    }
    var plus = $('#plpPlus'), more = $('#plpMore');
    if (more) more.addEventListener('click', function () {
      var avant = affiches;
      etat.vus = Math.max(etat.vus, affiches) + PAS;
      remplir(etat.vus);
      majPlus();
      majHauteur();
      ecrireURL();
      // Focus sur la première carte ajoutée : le clavier reprend là où la liste s'est allongée.
      var nouvelle = grille.children[avant];
      var lien = nouvelle && (nouvelle.matches('a') ? nouvelle : nouvelle.querySelector('a'));
      if (lien) lien.focus({ preventScroll: true });
    });
    function majPlus() {
      if (!plus) return;
      plus.hidden = affiches >= courant.length;
    }

    // --- Compteur, vide, URL -----------------------------------------------------------------------------------------------------
    var vide = $('#collVide');
    function majCompte(n) {
      var label = $('#collCompte');
      if (label) {
        label.textContent = '';
        var b = document.createElement('b'); b.textContent = n;
        var i = document.createElement('i'); i.textContent = 'résultat' + (n > 1 ? 's' : '');
        label.appendChild(b); label.appendChild(document.createTextNode(' ')); label.appendChild(i);
      }
      if (voir) voir.textContent = n ? 'Voir ' + (n > 1 ? 'les ' + n + ' résultats' : 'le résultat') : 'Aucun résultat';
    }
    function majVide(n) {
      if (!vide) return;
      if (n) { vide.hidden = true; vide.textContent = ''; return; }
      if (!base.length) {
        vide.innerHTML = '<p>Aucun modèle dans cette sélection pour le moment.</p><a class="btn btn--outline plp-vide__lien" href="/collections/all">Voir tous les modèles</a>';
      } else {
        vide.innerHTML = '<p>Aucun modèle ne correspond à ces filtres.</p><button type="button" class="btn btn--outline plp-vide__lien" id="collVideEffacer">Tout effacer</button>';
        var x = $('#collVideEffacer');
        if (x) x.addEventListener('click', function () { etat.cat = []; etat.activite = []; etat.taille = []; etat.vus = PAS; rendre(); });
      }
      vide.hidden = false;
    }
    function ecrireURL() {
      if (!window.history || !history.replaceState) return;
      try {
        var u = new URL(location.href);
        [['cat', etat.cat], ['activite', etat.activite], ['taille', etat.taille]].forEach(function (p) {
          if (p[1].length) u.searchParams.set(p[0], p[1].join(',')); else u.searchParams.delete(p[0]);
        });
        if (etat.tri !== 'selection') u.searchParams.set('tri', etat.tri); else u.searchParams.delete('tri');
        if (etat.vus > PAS) u.searchParams.set('vus', etat.vus); else u.searchParams.delete('vus');
        var s = u.searchParams.toString().replace(/%2C/gi, ',');
        history.replaceState(history.state, '', u.pathname + (s ? '?' + s : '') + u.hash);
      } catch (e) {}
    }

    function rendre(o) {
      o = o || {};
      courant = resultats();
      grille.textContent = '';
      affiches = 0;
      remplir(Math.max(PAS, etat.vus));
      majPlus();
      majCompte(courant.length);
      majVide(courant.length);
      majOnglets();
      majActivites();
      majTailles();
      syncTri();
      pills();
      majBouton();
      majHauteur();
      ecrireURL();
      if (o.garderFocus) {
        var f = null;
        o.garderFocus.split(', ').some(function (s) { f = $('#panneauFiltres ' + s) || $(s); return !!f; });
        if (f) { if (!f.hasAttribute('tabindex') && /^H\d$/.test(f.tagName)) f.setAttribute('tabindex', '-1'); f.focus({ preventScroll: true }); }
      }
    }

    // Base vide (rayon sans modèle) : ni onglets, ni barre, ni volet — seulement le message.
    if (!base.length) {
      ['#collFiltres', '#plpTete .plp-bar', '#panneauFiltres'].forEach(function (s) { var x = $(s); if (x) x.hidden = true; });
    }
    rendre();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
